/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Financial } from '../../models/financial';

export interface FinancialTransactionDetail$Params {
  Encounterno?: string | null;
  PatientId?: string | null;
  PracticeId?: string | null;
  ServiceItem?: string | null;
  Dateofservice?: string | null;
  charge_id?: string | null;
}

export function financialTransactionDetail(http: HttpClient, rootUrl: string, params?: FinancialTransactionDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<Financial>> {
  const rb = new RequestBuilder(rootUrl, financialTransactionDetail.PATH, 'get');
  if (params) {
    rb.query('Encounterno', params.Encounterno, {});
    rb.query('PatientId', params.PatientId, {});
    rb.query('PracticeId', params.PracticeId, {});
    rb.query('ServiceItem', params.ServiceItem, {});
    rb.query('Dateofservice', params.Dateofservice, {});
    rb.query('charge_id', params.charge_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Financial>;
    })
  );
}

financialTransactionDetail.PATH = '/financial/transactionDetail';
